import { render, staticRenderFns } from "./ImageClipper.vue?vue&type=template&id=c4530284&scoped=true&lang=pug"
import script from "./ImageClipper.vue?vue&type=script&lang=ts"
export * from "./ImageClipper.vue?vue&type=script&lang=ts"
import style0 from "./ImageClipper.vue?vue&type=style&index=0&id=c4530284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4530284",
  null
  
)

export default component.exports